(function () {
  const SELECTORS = {
    calculator: "[data-birdblocker-calculator]",
    settings: "[data-calculator-settings]",
    products: "[data-calculator-products]",
    field: "[data-field]",
    choice: "[data-choice-field]",
    conditional: "[data-conditional]",
    step: "[data-step]",
    error: "[data-step-error]",
    feedback: "[data-step-feedback]",
    results: "[data-results]",
    progressStep: "[data-progress-step]",
    progressBar: "[data-progress-bar]",
    status: "[data-status-message]"
  };

  const formatNumber = (value, digits = 1) =>
    new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(value);

  const formatInteger = (value) =>
    new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }).format(value);

  const formatCurrency = (value, currencyCode = "USD") =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2
    }).format((value || 0) / 100);

  const interpolate = (template, values = {}) =>
    String(template || "").replace(/\{(\w+)\}/g, (_, key) => (key in values ? values[key] : ""));

  const pushAnalyticsEvent = (eventName, payload = {}) => {
    const eventPayload = {
      event: eventName,
      tool: "birdblocker_calculator",
      locale: document.documentElement.lang || "en",
      path: window.location.pathname,
      ...payload
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    window.dispatchEvent(new CustomEvent("birdblocker:analytics", { detail: eventPayload }));
  };

  const syncOverlayLocks = () => {
    const hasOpenModal = Boolean(document.querySelector(".bb-modal:not([hidden])"));
    const hasOpenLightbox = Boolean(document.querySelector(".bb-lightbox:not([hidden])"));

    document.documentElement.classList.toggle("bb-modal-open", hasOpenModal);
    document.body.classList.toggle("bb-modal-open", hasOpenModal);
    document.documentElement.classList.toggle("bb-lightbox-open", hasOpenLightbox);
    document.body.classList.toggle("bb-lightbox-open", hasOpenLightbox);
  };

  const updateCartCountUi = (cart) => {
    if (!cart) return;
    const count = cart.item_count || 0;
    const selectors = [
      "[data-cart-count]",
      "[data-cart-count-text]",
      ".cart-count-bubble span",
      ".cart-count",
      ".header__icon .count"
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        node.textContent = String(count);
      });
    });

    document.querySelectorAll(".cart-count-bubble").forEach((node) => {
      node.hidden = count === 0;
      node.classList.toggle("is-hidden", count === 0);
    });
  };

  const notifyCartUpdated = (cart, items) => {
    const detail = { cart, items, source: "birdblocker-calculator" };
    document.dispatchEvent(new CustomEvent("birdblocker:cart-updated", { detail }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail }));
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { detail }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { detail }));
    window.dispatchEvent(new CustomEvent("cart:updated", { detail }));
  };

  const fetchCartState = async () => {
    const response = await fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      }
    });
    if (!response.ok) throw new Error("Cart fetch failed");
    return response.json();
  };

  const getSectionsToRender = () => {
    const sectionIds = new Set(["cart-icon-bubble", "cart-live-region-text"]);

    if (document.querySelector("cart-notification")) {
      sectionIds.add("cart-notification-product");
      sectionIds.add("cart-notification-button");
    }

    if (document.querySelector("cart-drawer")) {
      sectionIds.add("cart-drawer");
    }

    return Array.from(sectionIds);
  };

  const renderThemeCart = (payload) => {
    if (!payload || !payload.sections) return false;

    const cartNotification = document.querySelector("cart-notification");
    if (cartNotification && typeof cartNotification.renderContents === "function" && payload.key) {
      cartNotification.renderContents(payload);
      return true;
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(payload);
      return true;
    }

    return false;
  };

  const refreshCartSections = async () => {
    const sectionIds = getSectionsToRender();
    const url = `${window.location.pathname}?sections=${sectionIds.join(",")}`;
    const response = await fetch(url, {
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) return null;
    const sections = await response.json();

    sectionIds.forEach((sectionId) => {
      const html = sections[sectionId];
      if (!html) return;

      if (sectionId === "cart-notification-product" || sectionId === "cart-notification-button") {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const target = document.getElementById(sectionId);
        const replacement = parsed.getElementById(sectionId);
        if (target && replacement) {
          target.innerHTML = replacement.innerHTML;
        }
        return;
      }

      const parsed = document.createElement("div");
      parsed.innerHTML = html;

      const incomingSection = parsed.querySelector(`#shopify-section-${sectionId}`) || parsed.firstElementChild;
      const existingSection = document.querySelector(`#shopify-section-${sectionId}`);

      if (incomingSection && existingSection) {
        existingSection.replaceWith(incomingSection);
      }
    });

    return sections;
  };

  const getAddedItemKey = (responseData) => {
    if (!responseData) return null;
    if (responseData.key) return responseData.key;
    if (Array.isArray(responseData.items) && responseData.items.length === 1) {
      return responseData.items[0].key || null;
    }
    return null;
  };

  const buildThemeCartPayload = (responseData, sections) => {
    if (!sections) return null;
    return {
      ...responseData,
      key: getAddedItemKey(responseData),
      sections
    };
  };

  const markResultButtonsAdded = (root, items, addedLabel) => {
    if (!root || !Array.isArray(items)) return;

    items.forEach((item) => {
      root.querySelectorAll(`[data-add-item="${item.id}"]`).forEach((button) => {
        button.disabled = true;
        button.dataset.added = "true";
        button.classList.add("is-added");
        button.textContent = addedLabel;
      });
    });
  };

  const filterAlreadyAddedItems = (root, items) =>
    (items || []).filter((item) => {
      const existingButton = root.querySelector(`[data-add-item="${item.id}"]`);
      return !existingButton || existingButton.dataset.added !== "true";
    });

  const getUpsellDescription = (key, frameType, settings) => {
    if (key === "cable_fix_pro_box") return settings.upsellDescriptionCableFixBox || "Secure loose solar cables against box-design frames with the matching clip profile.";
    if (key === "cable_fix_pro_traditional") return settings.upsellDescriptionCableFixTraditional || "Secure loose solar cables cleanly along traditional frame installations.";
    if (key === "installation_tool") return settings.upsellDescriptionInstallationTool || "Installer tool to speed up fitting and adjustment during BirdBlocker installs.";
    if (key === "starter_kit") return settings.upsellDescriptionStarterKit || "Starter kit with the core accessories needed for first-time BirdBlocker installations.";
    return frameType === "box"
      ? (settings.upsellDescriptionGenericBox || "Helpful add-on for box-design BirdBlocker installs.")
      : (settings.upsellDescriptionGeneric || "Helpful add-on for BirdBlocker installs.");
  };

  const parseJson = (element, selector) => {
    const node = element.querySelector(selector);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const safeNumber = (value) => {
    if (value === "" || value === null || typeof value === "undefined") return null;
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  };

  const ceilStrips = (meters) => Math.ceil((meters * 100) / 50);
  const ceilPacks50 = (quantity) => Math.ceil(quantity / 50);

  const chooseVariantKeyForDepth = (depth, thresholds) => {
    if (depth >= 0 && depth <= thresholds.bb85Max) return "85";
    if (depth > thresholds.bb85Max && depth <= thresholds.bb125Max) return "125";
    if (depth > thresholds.bb125Max && depth <= thresholds.bb200Max) return "200";
    return null;
  };

  const chooseBoxclipKey = (frameHeight, frameDepth, preferredFinish) => {
    let sizePrefix = null;
    if (frameDepth >= 8 && frameDepth <= 13) sizePrefix = "boxclip_8_13";
    if (frameDepth >= 14 && frameDepth <= 18) sizePrefix = "boxclip_14_18";
    if (!sizePrefix) return null;

    if (frameHeight === 30) {
      if (sizePrefix === "boxclip_14_18") {
        return preferredFinish === "silver"
          ? "boxclip_14_18_30_silver"
          : "boxclip_14_18_30_black";
      }
      return `${sizePrefix}_30`;
    }
    if (frameHeight === 35) {
      if (sizePrefix === "boxclip_14_18") return "boxclip_14_18_35";
      return "boxclip_8_13_35";
    }
    return null;
  };

  const rankPackCandidates = (candidates) => {
    let best = null;

    candidates.forEach((candidate) => {
      if (!best) {
        best = candidate;
        return;
      }

      if (candidate.thirty > best.thirty) {
        best = candidate;
        return;
      }

      if (candidate.thirty === best.thirty && candidate.waste < best.waste) {
        best = candidate;
      }
    });

    return best;
  };

  const getPackRecommendation = (requiredMeters, options = {}) => {
    const allowThirty = options.allowThirty !== false;
    const allowTen = options.allowTen !== false;
    const maxThirty = Math.ceil(requiredMeters / 30) + 1;
    const allCandidates = [];

    for (let thirty = 0; thirty <= (allowThirty ? maxThirty : 0); thirty += 1) {
      const maxTen = allowTen ? Math.ceil(Math.max(requiredMeters - thirty * 30, 0) / 10) + 1 : 0;
      for (let ten = 0; ten <= maxTen; ten += 1) {
        const totalMeters = thirty * 30 + ten * 10;
        if (totalMeters < requiredMeters) continue;
        allCandidates.push({
          thirty,
          ten,
          totalMeters,
          waste: totalMeters - requiredMeters
        });
      }
    }

    const practicalCandidates = allCandidates.filter((candidate) => candidate.waste <= 20);
    return (
      rankPackCandidates(practicalCandidates) ||
      rankPackCandidates(allCandidates) || {
        thirty: allowThirty ? Math.ceil(requiredMeters / 30) : 0,
        ten: allowTen ? Math.ceil(requiredMeters / 10) : 0,
        totalMeters: (allowThirty ? Math.ceil(requiredMeters / 30) * 30 : 0) + (allowTen ? Math.ceil(requiredMeters / 10) * 10 : 0),
        waste: ((allowThirty ? Math.ceil(requiredMeters / 30) * 30 : 0) + (allowTen ? Math.ceil(requiredMeters / 10) * 10 : 0)) - requiredMeters
      }
    );
  };

  class BirdBlockerCalculator {
    constructor(root) {
      this.root = root;
      this.settings = parseJson(root, SELECTORS.settings);
      this.products = parseJson(root, SELECTORS.products);
      this.steps = Array.from(root.querySelectorAll(SELECTORS.step));
      this.progressSteps = Array.from(root.querySelectorAll(SELECTORS.progressStep));
      this.progressBar = root.querySelector(SELECTORS.progressBar);
      this.resultsNode = root.querySelector(SELECTORS.results);
      this.statusNode = root.querySelector(SELECTORS.status);
      this.lightbox = root.closest(".bb-calculator-modal-wrapper")?.querySelector("[data-tooltip-lightbox]") || null;
      this.lightboxImage = this.lightbox ? this.lightbox.querySelector(".bb-lightbox__image") : null;
      this.currentStep = 1;
      this.state = {
        frameHasTraditional: "yes"
      };
      this.mode = root.dataset.mode || "static";
      this.instanceId = root.dataset.instanceId || "default";

      this.bindEvents();
      this.syncStateFromDom();
      this.updateUI();
      this.updateFeedback();
    }

    track(eventName, payload = {}) {
      pushAnalyticsEvent(eventName, {
        mode: this.mode,
        instance_id: this.instanceId,
        step: this.currentStep,
        ...payload
      });
    }

    getAnalyticsStateSummary(extra = {}) {
      const depth = safeNumber(this.state.roofDepth);
      const thresholds = this.settings.thresholds || {};
      const birdblockerVariant = depth === null ? null : chooseVariantKeyForDepth(depth, thresholds);
      const hasTraditional = this.state.frameHasTraditional === "yes";
      const hasBox = this.state.frameHasBox === "yes";

      let frameStyle = "";
      if (hasTraditional && hasBox) frameStyle = "traditional_plus_box";
      else if (hasBox) frameStyle = "box";
      else if (hasTraditional) frameStyle = "traditional";

      return {
        roof_clearance_mm: depth,
        recommended_variant: birdblockerVariant,
        frame_style: frameStyle,
        boxclips_required: hasBox,
        ...extra
      };
    }

    syncStateFromDom() {
      this.root.querySelectorAll(SELECTORS.field).forEach((field) => {
        this.state[field.dataset.field] = field.value;
      });

      this.root.querySelectorAll(".bb-choice.is-selected").forEach((button) => {
        this.state[button.dataset.choiceField] = button.dataset.choiceValue;
      });
    }

    bindEvents() {
      this.root.addEventListener("click", (event) => {
        const tooltipLightboxOpen = event.target.closest("[data-tooltip-lightbox-open]");
        if (tooltipLightboxOpen) {
          event.preventDefault();
          this.openTooltipLightbox(tooltipLightboxOpen);
          return;
        }

        const choice = event.target.closest(SELECTORS.choice);
        if (choice) {
          this.handleChoice(choice);
          return;
        }

        const action = event.target.closest("[data-action]");
        if (action) {
          this.handleAction(action.dataset.action);
          return;
        }

        const addItem = event.target.closest("[data-add-item]");
        if (addItem) {
          this.track("birdblocker_product_add_clicked", {
            source: "single",
            variant_id: Number(addItem.dataset.addItem),
            quantity: Number(addItem.dataset.quantity || 1)
          });
          this.addItemsToCart([{ id: Number(addItem.dataset.addItem), quantity: Number(addItem.dataset.quantity || 1) }], addItem, { source: "single" });
          return;
        }

        const addAll = event.target.closest("[data-add-all]");
        if (addAll) {
          const items = JSON.parse(addAll.dataset.items || "[]");
          const pendingItems = filterAlreadyAddedItems(this.root, items);
          this.track("birdblocker_add_all_clicked", {
            recommended_items: items.length,
            pending_items: pendingItems.length
          });
          if (!pendingItems.length) {
            addAll.disabled = true;
            addAll.dataset.added = "true";
            addAll.classList.add("is-added");
            addAll.textContent = this.settings.addedLabel;
            const goToCart = this.root.querySelector("[data-go-to-cart]");
            if (goToCart) goToCart.hidden = false;
            return;
          }
          this.addItemsToCart(pendingItems, addAll, { source: "add_all" });
          return;
        }

        const goToCart = event.target.closest("[data-go-to-cart]");
        if (goToCart) {
          this.track("birdblocker_go_to_cart_clicked");
          return;
        }

        const recalculate = event.target.closest("[data-recalculate]");
        if (recalculate) {
          this.reset();
          return;
        }

        const breakdownToggle = event.target.closest("[data-breakdown-toggle]");
        if (breakdownToggle) {
          const content = this.root.querySelector("[data-breakdown-content]");
          const expanded = breakdownToggle.getAttribute("aria-expanded") === "true";
          breakdownToggle.setAttribute("aria-expanded", String(!expanded));
          breakdownToggle.classList.toggle("is-open", !expanded);
          if (content) content.hidden = expanded;
          return;
        }

        const tooltipTrigger = event.target.closest(".bb-tooltip__trigger");
        if (tooltipTrigger) {
          if (tooltipTrigger.closest("[data-box-design-panel].is-disabled")) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          const expanded = tooltipTrigger.getAttribute("aria-expanded") === "true";
          this.root.querySelectorAll(".bb-tooltip__trigger[aria-expanded='true']").forEach((node) => {
            if (node !== tooltipTrigger) node.setAttribute("aria-expanded", "false");
          });
          tooltipTrigger.setAttribute("aria-expanded", String(!expanded));
          if (!expanded) {
            const fieldLabel = tooltipTrigger.closest(".bb-field, .bb-choice-group")?.querySelector(".bb-field__label, .bb-choice-group__label")?.textContent?.trim() || "";
            this.track("birdblocker_tooltip_opened", { field_label: fieldLabel });
          }
          event.stopPropagation();
          return;
        }

        const tooltipClose = event.target.closest("[data-tooltip-close]");
        if (tooltipClose) {
          const tooltip = tooltipClose.closest("[data-tooltip]");
          const trigger = tooltip ? tooltip.querySelector(".bb-tooltip__trigger") : null;
          if (trigger) trigger.setAttribute("aria-expanded", "false");
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (!event.target.closest("[data-tooltip]")) {
          this.root.querySelectorAll(".bb-tooltip__trigger[aria-expanded='true']").forEach((node) => {
            node.setAttribute("aria-expanded", "false");
          });
        }
      });

      if (this.lightbox && this.lightbox.dataset.lightboxReady !== "true") {
        this.lightbox.dataset.lightboxReady = "true";

        this.lightbox.addEventListener("click", (event) => {
          if (event.target === this.lightbox || event.target.closest("[data-tooltip-lightbox-close]")) {
            event.preventDefault();
            this.closeTooltipLightbox();
          }
        });
      }

      document.addEventListener("click", (event) => {
        if (this.root.contains(event.target)) return;
        this.root.querySelectorAll(".bb-tooltip__trigger[aria-expanded='true']").forEach((node) => {
          node.setAttribute("aria-expanded", "false");
        });
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.lightbox && !this.lightbox.hidden) {
          this.closeTooltipLightbox();
        }
      });

      this.root.addEventListener("input", (event) => {
        const field = event.target.closest(SELECTORS.field);
        if (!field) return;
        this.state[field.dataset.field] = event.target.value;
        this.clearError(this.currentStep);
        this.updateFeedback();
      });

      this.root.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;

        const field = event.target.closest(SELECTORS.field);
        if (!field) return;

        const currentStep = this.root.querySelector(`${SELECTORS.step}[data-step="${this.currentStep}"]`);
        if (!currentStep) return;

        const visibleFields = Array.from(currentStep.querySelectorAll(SELECTORS.field)).filter((input) => {
          const conditionalParent = input.closest("[data-box-design-panel]");
          if (conditionalParent && conditionalParent.classList.contains("is-disabled")) return false;
          return !input.disabled && input.offsetParent !== null;
        });

        if (!visibleFields.length || visibleFields[visibleFields.length - 1] !== field) return;
        if (this.currentStep >= this.steps.length) return;

        event.preventDefault();
        this.handleAction("next");
      });
    }

    openTooltipLightbox(trigger) {
      if (!this.lightbox || !this.lightboxImage) return;

      const imageUrl = trigger.getAttribute("href");
      const image = trigger.querySelector("img");

      if (!imageUrl) return;

      this.lightboxImage.src = imageUrl;
      this.lightboxImage.alt = image?.getAttribute("alt") || "";
      this.lightbox.hidden = false;
      syncOverlayLocks();
    }

    closeTooltipLightbox() {
      if (!this.lightbox || !this.lightboxImage) return;

      this.lightbox.hidden = true;
      this.lightboxImage.removeAttribute("src");
      this.lightboxImage.alt = "";
      syncOverlayLocks();
    }

    handleChoice(choice) {
      const { choiceField, choiceValue } = choice.dataset;
      if (choice.dataset.choiceToggle === "true") {
        const isSelected = choice.classList.contains("is-selected");
        this.state[choiceField] = isSelected ? "no" : choiceValue;
        choice.classList.toggle("is-selected", !isSelected);
        this.clearError(this.currentStep);
        this.updateUI();
        this.updateFeedback();
        return;
      }

      this.state[choiceField] = choiceValue;

      this.root.querySelectorAll(`[data-choice-field="${choiceField}"]`).forEach((button) => {
        button.classList.toggle("is-selected", button === choice);
      });

      this.root.querySelectorAll(`[data-conditional="${choiceField}"]`).forEach((block) => {
        block.hidden = block.dataset.conditionalValue !== choiceValue;
      });

      this.clearError(this.currentStep);
      this.updateFeedback();
    }

    handleAction(action) {
      if (action === "next") {
        this.syncStateFromDom();
        if (!this.validateStep(this.currentStep)) return;
        this.track("birdblocker_step_completed", this.getAnalyticsStateSummary({ completed_step: this.currentStep }));
        if (this.currentStep === 3) {
          this.renderResults();
        }
        this.currentStep = Math.min(4, this.currentStep + 1);
        this.updateUI();
      }

      if (action === "prev") {
        this.currentStep = Math.max(1, this.currentStep - 1);
        this.updateUI();
      }

      if (action === "cart") {
        window.location.href = "/cart";
      }
    }

    updateUI() {
      this.syncStateFromDom();
      this.steps.forEach((step) => {
        const active = Number(step.dataset.step) === this.currentStep;
        step.hidden = !active;
        step.classList.toggle("is-active", active);
      });

      this.progressSteps.forEach((step, index) => {
        step.classList.toggle("is-active", index + 1 <= this.currentStep);
      });

      if (this.progressBar) {
        this.progressBar.style.width = `${((this.currentStep - 1) / (this.steps.length - 1)) * 100}%`;
      }

      const prevButton = this.root.querySelector('[data-action="prev"]');
      const nextButton = this.root.querySelector('[data-action="next"]');
      const cartButton = this.root.querySelector('[data-action="cart"]');
      const actionButton = nextButton || cartButton;
      const actionsRow = this.root.querySelector(".bb-calculator__actions");

      if (prevButton) prevButton.disabled = this.currentStep === 1;
      if (actionsRow) actionsRow.hidden = this.currentStep === 4;
      if (actionButton) {
        actionButton.hidden = this.currentStep === 4;
        actionButton.dataset.action = "next";
        actionButton.textContent = this.currentStep === 3
          ? (this.settings.seeResultsLabel || "See results")
          : (this.settings.nextLabel || "Next");
      }

      const boxPanel = this.root.querySelector("[data-box-design-panel]");
      if (boxPanel) {
        boxPanel.classList.toggle("is-disabled", this.state.frameHasBox !== "yes");
      }

      this.updateFeedback();
    }

    setError(stepNumber, message) {
      const step = this.root.querySelector(`${SELECTORS.step}[data-step="${stepNumber}"]`);
      const errorNode = step ? step.querySelector(SELECTORS.error) : null;
      if (errorNode) errorNode.textContent = message;
    }

    clearError(stepNumber) {
      const step = this.root.querySelector(`${SELECTORS.step}[data-step="${stepNumber}"]`);
      const errorNode = step ? step.querySelector(SELECTORS.error) : null;
      if (errorNode) errorNode.textContent = "";
      if (step) {
        step.querySelectorAll(".is-invalid").forEach((node) => node.classList.remove("is-invalid"));
      }
    }

    markFieldInvalids(fieldNames) {
      fieldNames.forEach((fieldName) => {
        const field = this.root.querySelector(`[data-field="${fieldName}"]`);
        if (field) field.classList.add("is-invalid");
      });
    }

    markChoiceInvalid(choiceField) {
      const button = this.root.querySelector(`[data-choice-field="${choiceField}"]`);
      const row = button ? button.closest(".bb-choice-row") : null;
      if (row) row.classList.add("is-invalid");
    }

    setFeedback(stepNumber, message) {
      const step = this.root.querySelector(`${SELECTORS.step}[data-step="${stepNumber}"]`);
      const feedbackNode = step ? step.querySelector(SELECTORS.feedback) : null;
      if (!feedbackNode) return;
      feedbackNode.hidden = !message;
      feedbackNode.innerHTML = message || "";
    }

    updateFeedback() {
      const thresholds = this.settings.thresholds || {};
      const base = this.calculateBaseLengths();

      if ((safeNumber(this.state.panelWidth) || 0) > 0 && (safeNumber(this.state.panelHeight) || 0) > 0 && ((safeNumber(this.state.exposedShortSides) || 0) + (safeNumber(this.state.exposedLongSides) || 0)) > 0) {
        this.setFeedback(1, `&#10003; ${interpolate(this.settings.step1FeedbackTemplate || "Estimated BirdBlocker length with 10% installation buffer: {meters} m.", { meters: formatNumber(base.totalMeters, 2) })}`);
      } else {
        this.setFeedback(1, "");
      }

      const depth = safeNumber(this.state.roofDepth);
      const variant = depth === null ? null : chooseVariantKeyForDepth(depth, thresholds);
      if (variant) {
        const rangeLabel = variant === "85"
          ? `0-${thresholds.bb85Max}`
          : variant === "125"
            ? `${thresholds.bb85Max}-${thresholds.bb125Max}`
            : `${thresholds.bb125Max}-${thresholds.bb200Max}`;
        this.setFeedback(2, `&#10003; ${interpolate(this.settings.step2FeedbackTemplate || "BirdBlocker {variant}mm covers the {range} mm roof-clearance range.", {
          variant,
          range: rangeLabel
        })}`);
      } else {
        this.setFeedback(2, "");
      }

      if (this.state.frameHasBox === "yes") {
        const frameHeight = safeNumber(this.state.frameHeight);
        const frameDepth = safeNumber(this.state.frameDepth);
        const roundedDepth = frameDepth === null ? null : Math.round(frameDepth);
        const key = chooseBoxclipKey(frameHeight, roundedDepth, this.settings.preferredBoxclip35Finish);
        const product = key ? this.products[key] : null;
        if (product) {
          this.setFeedback(3, `&#10003; ${interpolate(this.settings.step3FeedbackMatchTemplate || "{product} matches a {height} mm height and {depth} mm depth box-design frame.", {
            product: product.title,
            height: frameHeight,
            depth: roundedDepth
          })}`);
        } else if (this.state.frameHasTraditional === "yes") {
          this.setFeedback(3, `&#10003; ${this.settings.feedbackFrameBoth || "Traditional and box-design frame styles selected. BoxClips will be calculated for the box-design short sides."}`);
        } else {
          this.setFeedback(3, "");
        }
      } else if (this.state.frameHasTraditional === "yes") {
        this.setFeedback(3, `&#10003; ${this.settings.feedbackFrameTraditional || "Traditional frame selected. Standard BirdBlocker clips will be used."}`);
      } else {
        this.setFeedback(3, "");
      }
    }

    validateStep(stepNumber) {
      this.clearError(stepNumber);
      const t = this.settings.thresholds || {};

      if (stepNumber === 1) {
        const width = safeNumber(this.state.panelWidth);
        const height = safeNumber(this.state.panelHeight);
        const shortSides = safeNumber(this.state.exposedShortSides);
        const longSides = safeNumber(this.state.exposedLongSides);

        if ([width, height, shortSides, longSides].some((value) => value === null)) {
          this.markFieldInvalids(["panelWidth", "panelHeight", "exposedShortSides", "exposedLongSides"]);
          this.setError(1, this.settings.errorPanelDetailsRequired || "Enter numeric values for all panel details before continuing.");
          this.track("birdblocker_validation_error", { error_key: "panel_details_required" });
          return false;
        }

        if (width <= 0 || height <= 0 || shortSides < 0 || longSides < 0) {
          this.markFieldInvalids(["panelWidth", "panelHeight", "exposedShortSides", "exposedLongSides"]);
          this.setError(1, this.settings.errorPanelDetailsInvalid || "Panel dimensions must be greater than zero and exposed side counts cannot be negative.");
          this.track("birdblocker_validation_error", { error_key: "panel_details_invalid" });
          return false;
        }

        if (shortSides === 0 && longSides === 0) {
          this.setError(1, this.settings.errorExposedRequired || "At least one exposed side is required to continue.");
          this.track("birdblocker_validation_error", { error_key: "exposed_required" });
          return false;
        }

      }

      if (stepNumber === 2) {
        const depth = safeNumber(this.state.roofDepth);
        if (depth === null) {
          this.markFieldInvalids(["roofDepth"]);
          this.setError(2, this.settings.errorRoofClearanceRequired || "Enter the roof clearance in millimetres.");
          this.track("birdblocker_validation_error", { error_key: "roof_clearance_required" });
          return false;
        }

        if (depth < 0 || depth > t.bb200Max) {
          this.markFieldInvalids(["roofDepth"]);
          this.setError(2, interpolate(this.settings.errorRoofClearanceRange || "Roof clearance must be between 0 mm and {max} mm.", { max: t.bb200Max }));
          this.track("birdblocker_validation_error", { error_key: "roof_clearance_range" });
          return false;
        }
      }

      if (stepNumber === 3) {
        const hasTraditional = this.state.frameHasTraditional === "yes";
        const hasBox = this.state.frameHasBox === "yes";

        if (!hasTraditional && !hasBox) {
          this.markChoiceInvalid("frameHasTraditional");
          this.markChoiceInvalid("frameHasBox");
          this.setError(3, this.settings.errorFrameStyleRequired || "Select at least one panel frame style.");
          this.track("birdblocker_validation_error", { error_key: "frame_style_required" });
          return false;
        }

        if (hasBox) {
          const height = safeNumber(this.state.frameHeight);
          const depth = safeNumber(this.state.frameDepth);
          const roundedDepth = depth === null ? null : Math.round(depth);
          if (height === null || depth === null) {
            this.markFieldInvalids(["frameHeight", "frameDepth"]);
            this.setError(3, this.settings.errorBoxclipRequired || "Enter the BoxClip height and depth for box-design frames.");
            this.track("birdblocker_validation_error", { error_key: "boxclip_required" });
            return false;
          }

          if (!chooseBoxclipKey(height, roundedDepth, this.settings.preferredBoxclip35Finish)) {
            this.markFieldInvalids(["frameHeight", "frameDepth"]);
            this.setError(3, this.settings.errorBoxclipInvalid || "BoxClip height must be 30 mm or 35 mm, and depth must be 8-13 mm or 14-18 mm. If your frame falls outside this range, please contact info@weprotectsolar.com for assistance.");
            this.track("birdblocker_validation_error", { error_key: "boxclip_invalid" });
            return false;
          }
        }
      }

      return true;
    }

    calculateBaseLengths() {
      const panelWidth = safeNumber(this.state.panelWidth) || 0;
      const panelHeight = safeNumber(this.state.panelHeight) || 0;
      const exposedShortSides = safeNumber(this.state.exposedShortSides) || 0;
      const exposedLongSides = safeNumber(this.state.exposedLongSides) || 0;
      const rawShortCm = panelWidth * exposedShortSides;
      const rawLongCm = panelHeight * exposedLongSides;
      const rawTotalCm = rawShortCm + rawLongCm;
      const bufferedShortCm = panelWidth * exposedShortSides * 1.1;
      const bufferedLongCm = panelHeight * exposedLongSides * 1.1;
      const bufferedTotalMeters = (bufferedShortCm + bufferedLongCm) / 100;
      const shortCm = bufferedShortCm;
      const longCm = bufferedLongCm;
      const totalCm = shortCm + longCm;
      return {
        rawShortCm,
        rawLongCm,
        rawTotalCm,
        rawShortMeters: rawShortCm / 100,
        rawLongMeters: rawLongCm / 100,
        rawTotalMeters: rawTotalCm / 100,
        shortCm,
        longCm,
        totalCm,
        shortMeters: shortCm / 100,
        longMeters: longCm / 100,
        totalMeters: totalCm / 100,
        bufferedTotalMeters,
        rawShortStrips: Math.ceil(rawShortCm / 50),
        rawLongStrips: Math.ceil(rawLongCm / 50),
        rawTotalStrips: Math.ceil(rawTotalCm / 50),
        shortStrips: Math.ceil(shortCm / 50),
        longStrips: Math.ceil(longCm / 50),
        totalStrips: Math.ceil(totalCm / 50)
      };
    }

    calculateRecommendations() {
      const base = this.calculateBaseLengths();
      const thresholds = this.settings.thresholds || {};
      const recommendations = [];
      const summary = [];

      const depth = safeNumber(this.state.roofDepth);
      const variant = chooseVariantKeyForDepth(depth, thresholds);
      if (variant) {
        recommendations.push({
          variant,
          label: `BirdBlocker ${variant}`,
          depthRangeSummary: `${depth} mm roof clearance`,
          requiredMeters: base.totalMeters,
          strips: base.totalStrips,
          packRecommendation: this.getBirdBlockerPackRecommendation(variant, base.totalMeters)
        });
        summary.push(interpolate(this.settings.roofClearanceBreakdown || "Roof clearance: {depth} mm using BirdBlocker {variant}.", { depth, variant }));
      }

      const boxclips = this.getBoxclipRecommendation(base);

      return {
        base,
        recommendations,
        boxclips,
        frameSummary: this.getFrameSummary(boxclips),
        summary,
        breakdown: this.buildBreakdown(base, recommendations, boxclips)
      };
    }

    buildBreakdown(base, recommendations, boxclips) {
      const lines = [
        `Panel: ${formatNumber(safeNumber(this.state.panelWidth) || 0, 1)} cm x ${formatNumber(safeNumber(this.state.panelHeight) || 0, 1)} cm`,
        `Exposed long sides: ${formatInteger(safeNumber(this.state.exposedLongSides) || 0)} x ${formatNumber((safeNumber(this.state.panelHeight) || 0) / 100, 3)} m = ${formatNumber(base.rawLongMeters, 3)} m`,
        `Exposed short sides: ${formatInteger(safeNumber(this.state.exposedShortSides) || 0)} x ${formatNumber((safeNumber(this.state.panelWidth) || 0) / 100, 3)} m = ${formatNumber(base.rawShortMeters, 3)} m`,
        interpolate(this.settings.rawPerimeterBreakdown || "Raw perimeter: {value} m", { value: formatNumber(base.rawTotalMeters, 3) }),
        `+10% buffer: ${formatNumber(base.bufferedTotalMeters, 3)} m`,
        `Order perimeter: ${formatNumber(base.totalMeters, 3)} m`
      ];

      recommendations.forEach((entry) => {
        lines.push(`${entry.label}: ${formatNumber(entry.requiredMeters, 1)} m -> ${entry.packRecommendation.thirty} x 30m, ${entry.packRecommendation.ten} x 10m`);
      });

      if (boxclips.required) {
        lines.push(interpolate(this.settings.boxclipsBreakdown || "{scope}: {meters} m raw perimeter, {clips} clips, {packs} pack(s)", {
          scope: boxclips.shortSidesOnly
            ? (this.settings.boxclipsScopeShort || "BoxClips (short sides only)")
            : (this.settings.boxclipsScopeAll || "BoxClips (all sides)"),
          meters: formatNumber(boxclips.applicableMeters, 3),
          clips: formatInteger(boxclips.totalClips),
          packs: formatInteger(boxclips.packs)
        }));
      }

      return lines;
    }

    getBoxclipRecommendation(base) {
      if (this.state.frameHasBox !== "yes") {
        return {
          required: false,
          summary: this.settings.frameSummaryTraditionalAssumed || "Traditional frame selected. Standard BirdBlocker clips assumed."
        };
      }

      const shortSidesOnly = this.state.frameHasTraditional === "yes";
      const applicableMeters = shortSidesOnly ? base.rawShortMeters : base.rawTotalMeters;
      const applicableStrips = shortSidesOnly ? base.rawShortStrips : base.rawTotalStrips;
      const totalClips = applicableStrips * 4;
      const packs = ceilPacks50(totalClips);
      const frameHeight = safeNumber(this.state.frameHeight);
      const frameDepth = safeNumber(this.state.frameDepth);
      const roundedDepth = frameDepth === null ? null : Math.round(frameDepth);
      const key = chooseBoxclipKey(frameHeight, roundedDepth, this.settings.preferredBoxclip35Finish);

      return {
        required: true,
        shortSidesOnly,
        totalClips,
        packs,
        applicableMeters,
        applicableStrips,
        productKey: key,
        frameHeight,
        frameDepth: roundedDepth,
        summary: shortSidesOnly
          ? (this.settings.frameSummaryBoxShort || "Box-design frame selected on short sides only.")
          : (this.settings.frameSummaryBoxAll || "Box-design frame selected on all exposed sides.")
      };
    }

    getFrameSummary(boxclips) {
      if (!boxclips.required) {
        return this.settings.frameSummaryTraditionalSelected || "Traditional frame. Standard BirdBlocker clips assumed.";
      }

      const coverage = boxclips.shortSidesOnly
        ? (this.settings.coverageSummaryShort || "BoxClips applied to short-side strips only.")
        : (this.settings.coverageSummaryAll || "BoxClips applied to all exposed strips.");
      return interpolate(this.settings.frameSummaryWithDimensions || "Box-design frame. Frame height {height} mm, frame depth {depth} mm. {coverage}", {
        height: boxclips.frameHeight,
        depth: boxclips.frameDepth,
        coverage
      });
    }

    getFrameStyleLabel() {
      if (this.state.frameHasTraditional === "yes" && this.state.frameHasBox === "yes") return this.settings.frameStyleTraditionalPlusBox || "Traditional + Box-design";
      if (this.state.frameHasBox === "yes") return this.settings.frameStyleBox || "Box-design";
      if (this.state.frameHasTraditional === "yes") return this.settings.frameStyleTraditional || "Traditional";
      return "";
    }

    getProductForVariant(variant, packSize) {
      return this.products[`birdblocker_${variant}_${packSize}`];
    }

    getBirdBlockerPackRecommendation(variant, requiredMeters) {
      if (variant === "85") {
        return getPackRecommendation(requiredMeters, { allowThirty: true, allowTen: false });
      }
      return getPackRecommendation(requiredMeters, { allowThirty: true, allowTen: true });
    }

    getBoxclipProduct(boxclips) {
      return boxclips.productKey ? this.products[boxclips.productKey] : null;
    }

    buildBirdBlockerItems(recommendations) {
      const grouped = new Map();

      recommendations.forEach((entry) => {
        [["30", entry.packRecommendation.thirty], ["10", entry.packRecommendation.ten]].forEach(([packSize, quantity]) => {
          if (!quantity) return;
          const product = this.getProductForVariant(entry.variant, packSize);
          if (!product || !product.variantId) return;
          const key = String(product.variantId);
          const existing = grouped.get(key);
          if (existing) {
            existing.quantity += quantity;
          } else {
            grouped.set(key, { product, quantity });
          }
        });
      });

      const entries = Array.from(grouped.values());
      const items = entries.map(({ product, quantity }) => ({ id: Number(product.variantId), quantity }));
      const totalCents = entries.reduce((sum, { product, quantity }) => sum + ((product.priceCents || 0) * quantity), 0);
      const cards = entries
        .map(({ product, quantity }) => this.buildResultProductCard(product, quantity, "", {
          singular: this.settings.quantityLabelBox || "Box",
          plural: this.settings.quantityLabelBoxes || "Boxes"
        }))
        .join("");

      return { cards, items, totalCents };
    }

    buildResultProductCard(product, quantity, detail, quantityLabels = { singular: "Box", plural: "Boxes" }) {
      if (!product || !product.variantId) return "";
      const image = product.image ? `<img src="${product.image}" alt="" loading="lazy">` : "";
      const lineTotal = (product.priceCents || 0) * quantity;
      const subline = [product.variantTitle, product.sku].filter(Boolean).join(" · ");
      const detailMarkup = detail ? `<div class="bb-result-product__detail">${detail}</div>` : "";
      const quantityLabel = `${formatInteger(quantity)}x ${quantity === 1 ? quantityLabels.singular : quantityLabels.plural}`;
      const addToCartLabel = interpolate(this.settings.addToCartQuantityTemplate || "Add {quantity} to cart", {
        quantity: formatInteger(quantity)
      });
      return `
        <article class="bb-result-product">
          <a class="bb-result-product__media" href="${product.url}">
            ${image}
          </a>
          <div class="bb-result-product__body">
            <div class="bb-result-product__title">${product.title}</div>
            <div class="bb-result-product__sku">${subline}</div>
            ${detailMarkup}
            <div class="bb-result-product__meta">
              <span class="bb-result-product__quantity">${quantityLabel}</span>
              <span>${formatCurrency(lineTotal, this.settings.currencyCode)}</span>
            </div>
            <button class="bb-button bb-result-product__button" type="button" data-add-item="${product.variantId}" data-quantity="${quantity}">
              ${addToCartLabel}
            </button>
          </div>
        </article>
      `;
    }

    buildBoxclipRow(boxclips) {
      if (!boxclips.required) return { card: "", item: null, totalCents: 0 };
      const product = this.getBoxclipProduct(boxclips);
      if (!product || !product.variantId) {
        return {
          card: `
            <article class="bb-result-product bb-result-product--empty">
              <div class="bb-result-product__body">
                <div class="bb-result-product__title">${this.settings.boxclipsRequiredTitle || "BoxClips required"}</div>
              </div>
            </article>
          `,
          item: null,
          totalCents: 0
        };
      }
      return {
        card: this.buildResultProductCard(product, boxclips.packs, "", {
          singular: this.settings.quantityLabelPack || "Pack",
          plural: this.settings.quantityLabelPacks || "Packs"
        }),
        item: { id: Number(product.variantId), quantity: boxclips.packs },
        totalCents: (product.priceCents || 0) * boxclips.packs
      };
    }

    renderResults() {
      const result = this.calculateRecommendations();
      const birdblockerItems = this.buildBirdBlockerItems(result.recommendations);
      const boxclipRow = this.buildBoxclipRow(result.boxclips);
      const upsells = this.buildUpsellRows();
      const addAllItems = [...birdblockerItems.items];
      if (boxclipRow.item) addAllItems.push(boxclipRow.item);
      const coreTotalCents = birdblockerItems.totalCents + boxclipRow.totalCents;

      this.resultsNode.innerHTML = `
        <div class="bb-results-page">
          <div class="bb-results-page__header">
            <div class="bb-results-page__summary">
              <h4>${this.settings.recommendedProductsHeading || "Recommended products"}</h4>
              <p>${formatCurrency(coreTotalCents, this.settings.currencyCode)} ${this.settings.resultsSummarySuffix || "total for recommended products. Full calculation details are underneath."}</p>
            </div>
            <div class="bb-results-page__actions">
              <button class="bb-button bb-button--accent bb-button--small" type="button" data-add-all data-items='${JSON.stringify(addAllItems)}'>${this.settings.addAllLabel}</button>
              <a class="bb-button bb-button--secondary bb-button--small" href="/cart" data-go-to-cart hidden>${this.settings.goToCartLabel || "Go to cart"}</a>
            </div>
          </div>
          <div class="bb-results-overview">
            <div class="bb-results-columns">
              <div class="bb-summary-section bb-summary-section--perimeter">
                <div class="bb-summary-section__title">${this.settings.perimeterCalculationTitle || "Perimeter calculation"}</div>
                <div class="bb-metric-row">
                  <span class="bb-metric-row__label">${this.settings.rawPerimeterLabel || "Raw perimeter"}</span>
                  <span class="bb-metric-row__value">${formatNumber(result.base.bufferedTotalMeters / 1.1, 2)} m</span>
                </div>
                <div class="bb-metric-row">
                  <span class="bb-metric-row__label">${this.settings.totalNeededLabel || "Total needed (with 10% installation buffer)"}</span>
                  <span class="bb-metric-row__value bb-metric-row__value--highlight">${formatNumber(result.base.totalMeters, 2)} m</span>
                </div>
                ${result.base.excludedMeters > 0 ? `
                  <div class="bb-metric-row">
                    <span class="bb-metric-row__label">${this.settings.excludedPerimeterLabel || "Excluded perimeter"}</span>
                    <span class="bb-metric-row__value">-${formatNumber(result.base.excludedMeters, 2)} m</span>
                  </div>
                ` : ""}
                <div class="bb-metric-row">
                  <span class="bb-metric-row__label">${this.settings.frameStyleLabel || "Frame style"}</span>
                  <span class="bb-metric-row__value">${this.getFrameStyleLabel()}</span>
                </div>
                ${result.boxclips.required ? `
                  <div class="bb-metric-row">
                    <span class="bb-metric-row__label">${this.settings.boxDesignLabel || "Box-design"}</span>
                    <span class="bb-metric-row__value">${result.boxclips.shortSidesOnly ? (this.settings.shortSidesOnlyLabel || "Short sides only") : (this.settings.wholeArrayLabel || "Whole array")}</span>
                  </div>
                ` : ""}
                <div class="bb-results-perimeter__actions">
                  <button class="bb-button bb-button--secondary bb-button--small" type="button" data-recalculate>${this.settings.recalculateLabel}</button>
                </div>
              </div>

              <div class="bb-summary-section bb-summary-section--dark bb-summary-section--birdblocker">
                <div class="bb-summary-section__title">${this.settings.productsNeededTitle || "Products needed for your installation"}</div>
                <div class="bb-result-product-grid">
                  ${birdblockerItems.cards}
                  ${result.boxclips.required ? boxclipRow.card : ""}
                </div>
              </div>
            </div>
          </div>

          ${upsells.rows ? `
            <div class="bb-results-extras">
              <div class="bb-results-extras__title">${this.settings.additionalAddonsTitle || "Additional helpful add-ons"} · ${formatCurrency(upsells.totalCents, this.settings.currencyCode)}</div>
              <div class="bb-results-extras__grid">${upsells.rows}</div>
            </div>
          ` : ""}

          <button class="bb-breakdown-toggle" type="button" data-breakdown-toggle aria-expanded="false">
            ${this.settings.showBreakdownLabel || "Show calculation breakdown"}
          </button>
          <div class="bb-breakdown-content" data-breakdown-content hidden>
            ${result.breakdown.map((line) => `<p>${line}</p>`).join("")}
          </div>
        </div>
      `;

      this.track("birdblocker_results_viewed", {
        recommended_variants: result.recommendations.map((entry) => entry.variant).join(","),
        boxclips_required: result.boxclips.required,
        products_count: birdblockerItems.items.length + (boxclipRow.item ? 1 : 0),
        total_value_cents: coreTotalCents
      });
    }

    buildUpsellRows() {
      if (!this.settings.enableUpsells) return { rows: "", items: [] };
      const keys = [];
      if (this.settings.enableCableFixPro) keys.push(this.state.frameHasBox === "yes" ? "cable_fix_pro_box" : "cable_fix_pro_traditional");
      if (this.settings.enableInstallationTool) keys.push("installation_tool");
      if (this.settings.enableStarterKit) keys.push("starter_kit");

      const items = [];
      let totalCents = 0;
      const rows = keys.map((key) => {
        const product = this.products[key];
        if (!product || !product.variantId) return "";
        items.push({ id: Number(product.variantId), quantity: 1 });
        totalCents += product.priceCents || 0;
        const image = product.image ? `<img src="${product.image}" alt="" loading="lazy">` : "";
        return `
          <div class="bb-extra-card">
            ${image ? `<div class="bb-extra-card__media">${image}</div>` : ""}
            <div class="bb-extra-card__body">
              <div class="bb-extra-card__title">${product.title}</div>
              <div class="bb-extra-card__meta">${getUpsellDescription(key, this.state.frameHasBox === "yes" ? "box" : "traditional", this.settings)}</div>
              <div class="bb-extra-card__price">${formatCurrency(product.priceCents || 0, this.settings.currencyCode)}</div>
              <button class="bb-button bb-button--secondary" type="button" data-add-item="${product.variantId}" data-quantity="1">
                ${this.settings.addItemLabel}
              </button>
            </div>
          </div>
        `;
      }).join("");

      return { rows, items, totalCents };
    }

    async addItemsToCart(items, button, meta = {}) {
      const validItems = items.filter((item) => item.id && item.quantity > 0);
      if (!validItems.length) return;

      if (button.dataset.added === "true") return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.settings.addingLabel || "Adding...";
      this.statusNode.textContent = "";

      try {
        let responseData = null;
        for (const item of validItems) {
          const response = await fetch(this.settings.cartEndpoint || "/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [item],
              sections: getSectionsToRender(),
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) {
            throw new Error("Cart request failed");
          }

          responseData = await response.json();
        }

        button.textContent = this.settings.addedLabel;
        this.statusNode.textContent = this.settings.itemsAddedMessage || "Items added to cart.";
        button.dataset.added = "true";
        button.classList.add("is-added");
        markResultButtonsAdded(this.root, validItems, this.settings.addedLabel);
        this.track("birdblocker_cart_add_success", {
          source: meta.source || "unknown",
          items_count: validItems.length,
          variant_ids: validItems.map((item) => item.id).join(","),
          quantities: validItems.map((item) => item.quantity).join(",")
        });
        if (button.hasAttribute("data-add-all")) {
          const goToCart = this.root.querySelector("[data-go-to-cart]");
          if (goToCart) goToCart.hidden = false;
        }

        try {
          const cart = await fetchCartState();
          const sections = responseData.sections || await refreshCartSections();
          const themePayload = buildThemeCartPayload(responseData, sections);
          const renderedByTheme = renderThemeCart(themePayload);
          if (!renderedByTheme) {
            if (!responseData.sections) {
              await refreshCartSections();
            }
          }
          updateCartCountUi(cart);
          notifyCartUpdated(cart, validItems);
        } catch (refreshError) {
          notifyCartUpdated(null, validItems);
        }
      } catch (error) {
        button.disabled = false;
        button.textContent = originalText;
        this.statusNode.textContent = this.settings.addErrorMessage || "Unable to add items to cart. Please try again.";
        this.track("birdblocker_cart_add_error", {
          source: meta.source || "unknown",
          items_count: validItems.length
        });
        return;
      }
    }

    reset() {
      this.state = {};
      this.root.querySelectorAll("input").forEach((input) => {
        input.value = "";
      });
      this.root.querySelectorAll(SELECTORS.choice).forEach((button) => {
        button.classList.remove("is-selected");
      });
      this.steps.forEach((step) => {
        const errorNode = step.querySelector(SELECTORS.error);
        if (errorNode) errorNode.textContent = "";
        const feedbackNode = step.querySelector(SELECTORS.feedback);
        if (feedbackNode) {
          feedbackNode.hidden = true;
          feedbackNode.innerHTML = "";
        }
      });
      if (this.resultsNode) this.resultsNode.innerHTML = "";
      if (this.statusNode) this.statusNode.textContent = "";
      this.currentStep = 1;
      this.updateUI();
      this.updateFeedback();
    }
  }

  const initModals = () => {
    const openModal = (modalId) => {
      const modal = document.querySelector(`[data-modal="${modalId}"]`);
      if (!modal) return false;
      modal.hidden = false;
      syncOverlayLocks();
      const calculator = modal.querySelector(SELECTORS.calculator);
      pushAnalyticsEvent("birdblocker_calculator_opened", {
        mode: calculator?.dataset.mode || "modal",
        instance_id: calculator?.dataset.instanceId || modalId
      });
      return true;
    };

    const closeModal = (modal) => {
      if (!modal) return false;
      modal.hidden = true;
      syncOverlayLocks();
      return true;
    };

    window.BirdBlockerCalculatorModal = {
      open: openModal,
      close(modalId) {
        const modal = document.querySelector(`[data-modal="${modalId}"]`);
        return closeModal(modal);
      }
    };

    const openHashModal = () => {
      if (window.location.hash !== "#birdblocker-calculator") return false;
      const modal = document.querySelector("[data-modal]");
      if (!modal) return false;
      return openModal(modal.dataset.modal);
    };

    document.addEventListener("click", (event) => {
      const anchorTrigger = event.target.closest('[href="#birdblocker-calculator"], [href$="#birdblocker-calculator"]');
      if (anchorTrigger) {
        if (!openHashModal()) return;
        event.preventDefault();
        return;
      }

      const openTrigger = event.target.closest("[data-modal-open]");
      if (openTrigger) {
        if (!openModal(openTrigger.dataset.modalOpen)) return;
        event.preventDefault();
        return;
      }

      const closeTrigger = event.target.closest("[data-modal-close]");
      if (closeTrigger) {
        const modal = closeTrigger.closest(".bb-modal");
        if (!closeModal(modal)) return;
        event.preventDefault();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      document.querySelectorAll("[data-tooltip-lightbox]").forEach((lightbox) => {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        const image = lightbox.querySelector(".bb-lightbox__image");
        if (image) {
          image.removeAttribute("src");
          image.alt = "";
        }
      });
      document.querySelectorAll("[data-modal]").forEach((modal) => {
        if (!modal.hidden) {
          closeModal(modal);
        }
      });
      syncOverlayLocks();
    });

    document.querySelectorAll("[data-modal]").forEach((modal) => {
      if (modal.dataset.modalReady === "true") return;
      modal.dataset.modalReady = "true";

      modal.addEventListener("click", (event) => {
        const closeTrigger = event.target.closest("[data-modal-close]");
        if (closeTrigger) {
          closeModal(modal);
          event.preventDefault();
          return;
        }

        if (event.target === modal) {
          closeModal(modal);
        }
      });
    });

    window.addEventListener("hashchange", () => {
      if (openHashModal()) {
        history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
      }
    });

    if (openHashModal()) {
      history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
    }
  };

  const init = () => {
    document.querySelectorAll(SELECTORS.calculator).forEach((node) => {
      if (node.dataset.calculatorReady === "true") return;
      node.dataset.calculatorReady = "true";
      new BirdBlockerCalculator(node);
    });
    initModals();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
